module.exports = __webpack_public_path__ + "static/img/banner5.5c88b09.png";


//////////////////
// WEBPACK FOOTER
// ./src/comm/images/document-conversion/onlinePreview/banner5.png
// module id = tsLI
// module chunks = 2